var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArpUncontrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.5 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill-opacity: 0;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 16.5,
    height: 16.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,8.1c0,.8-.7,1.4-1.5,1.4h-5.3v5.2c0,.8-.7,1.4-1.5,1.4s-1.5-.6-1.5-1.4v-5.2H1.5c-.8,0-1.5-.7-1.5-1.4s.7-1.5,1.5-1.5h5.3V1.4c0-.8.6-1.4,1.4-1.4s1.5.7,1.5,1.4v5.2h5.3c.8,0,1.5.7,1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArpUncontrolled);
export default __webpack_public_path__ + "static/media/arp_uncontrolled.90610ce971d94b41dce88a06ca11202f.svg";
export { ForwardRef as ReactComponent };